<template>
    <div style="display:flex;background:white">
        <div style="width:220px ;border-right:2px solid #389;" >
            <div style="display:flex;flex-direction:column;overflow-y:auto;height:91vh; background:white" > 
                <template v-for="(item, index) in menuList" > 
                    <div  class="oneMenu" :key="index" ><i class="iconfont icon-jichuziliaoguanli" style="margin-right:7px;"></i>基础规则</div>
                    <template v-for="(subitem ) in item.subs">
                        <span :key="subitem.frmurl"  v-if="openName.indexOf(item.subno)>-1">
                            <div  class="twoMenu">
                                <span  :class="{active: active===subitem.frmurl}" @click="itemClick(subitem.frmurl )">
                                    <i class="iconfont icon-xiayiye1" style="font-size:10px;margin-right:5px;"></i>
                                    {{subitem.cname}} 
                                </span>
                            </div>
                        </span>
                    </template>
                </template>  
            </div>
        </div>
        <div  v-if="active=='231138'">  
            <div style=" display:flex; width:100%; background:#fff;line-height:35px;height:35px;  border-bottom:1px solid #389">
                <span style="font-size:12px;padding-left:3px"><i class="iconfont icon-xuanze1" style="color:#389;margin-right:5px"></i>订单、运输周期</span>
                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-left:15px;margin-right:6px"></i>
                <el-link :disabled="editBool" @click="editShp " :underline="false"  ><span style="font-size:12px;line-height:40px;border-bottom:1px solid #409eff">编辑 </span></el-link>
            </div>  
            <div style="display:flex;line-height:35px;border:1px solid #ccc;background:white" v-for="(item,index) in ordArr" :key="index" >
                <div style="line-height:35px;width:120px;font-size:12px;border-right:1px solid #ccc;text-align:center;font-weight:700;color:#389 ">订单交付周期</div>
                <div style="line-height:35px;width:70px;font-size:12px;text-align:center; border-right:1px solid #ccc;">{{item.ORDDAY}}</div>
                <div style="line-height:35px;width:120px;font-size:12px;border-right:1px solid #ccc;text-align:center; font-weight:700;color:#389 ">运输周期</div>
                <div style="line-height:35px;width:70px;font-size:12px;text-align:center; border-right:1px solid #ccc;">{{item.SHPDAY}}</div>
            </div>
            <div style=" display:flex; width:100%; background:#fff;line-height:35px;height:35px;  border-bottom:1px solid #389">
                <span style="font-size:12px;padding-left:3px"><i class="iconfont icon-xuanze1" style="color:#389;margin-right:5px"></i>货币汇率</span>
                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-left:15px;margin-right:6px"></i>
                <el-link :disabled="editBool" @click="editRec " :underline="false"  ><span style="font-size:12px;line-height:40px;border-bottom:1px solid #409eff">编辑 </span></el-link>
            </div>      
            <div :style="{ 'height':tabHigh,'overflow-y':'auto'}">               
                <div :style="{'overflow':'auto','width':divWidth}">
                    <div :style="{'overflow-x':'auto','line-height':'40px','height':'40px','background':'white','display':'flex'}">
                        <div style="width:160px;border:1px solid #ccc;text-align:center;color:red;font-size:12px;font-weight:600">币种【2022】</div>
                        <div v-for="(item,index) in mthArr " :key="index" style="color:red;font-size:12px;font-weight:600;width:110px;border:1px solid #ccc;text-align:center">{{item.CNAME}}</div>
                    </div>
                </div>
                <div :style="{'overflow':'auto','width':divWidth}">
                    <div :style="{'overflow':'auto','line-height':'40px', 'background':'white' }">
                        <div v-for="(item,index) in tabData" :key="index" style="display:flex">
                            <div class="divcss">{{item.CRCYNM}}</div>
                            <div class="divcss2">{{item.C202201}}</div>
                            <div class="divcss2">{{item.C202202}}</div>
                            <div class="divcss2">{{item.C202203}}</div>
                            <div class="divcss2">{{item.C202204}}</div>
                            <div class="divcss2">{{item.C202205}}</div>
                            <div class="divcss2">{{item.C202206}}</div>
                            <div class="divcss2">{{item.C202207}}</div>
                            <div class="divcss2">{{item.C202208}}</div>
                            <div class="divcss2">{{item.C202209}}</div>
                            <div class="divcss2">{{item.C202210}}</div>
                            <div class="divcss2">{{item.C202211}}</div>
                            <div class="divcss2">{{item.C202212}}</div>
                        </div>
                    </div>
                </div>
                <!-- 2023年汇率 -->
                <div :style="{'overflow':'auto','width':divWidth,'margin-top':'3px'}">
                    <div :style="{'overflow-x':'auto','line-height':'40px','height':'40px','background':'white','display':'flex'}">
                        <div style="width:160px;border:1px solid #ccc;text-align:center;color:red;font-size:12px;font-weight:600">币种【2023】</div>
                        <div v-for="(item,index) in m3Arr " :key="index" style="color:red;font-size:12px;font-weight:600;width:110px;border:1px solid #ccc;text-align:center">{{item.CNAME}}</div>
                    </div>
                </div>
                <div :style="{'overflow':'auto','width':divWidth}">
                    <div :style="{ 'line-height':'40px', 'background':'white' }">
                        <div v-for="(item,index) in tabData" :key="index" style="display:flex">
                            <div class="divcss">{{item.CRCYNM}}</div>
                            <div class="divcss2">{{item.C202301}}</div>
                            <div class="divcss2">{{item.C202302}}</div>
                            <div class="divcss2">{{item.C202303}}</div>
                            <div class="divcss2">{{item.C202304}}</div>
                            <div class="divcss2">{{item.C202305}}</div>
                            <div class="divcss2">{{item.C202306}}</div>
                            <div class="divcss2">{{item.C202307}}</div>
                            <div class="divcss2">{{item.C202308}}</div>
                            <div class="divcss2">{{item.C202309}}</div>
                            <div class="divcss2">{{item.C202310}}</div>
                            <div class="divcss2">{{item.C202311}}</div>
                            <div class="divcss2">{{item.C202312}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 编辑货币 -->
            <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="editWin" :show-close="false"  :width="tabWidth" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="2vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">汇率维护</span>
                </div>
                <div style="height:89vh;overflow-y:auto">
                    <bs-crcy></bs-crcy>
                </div>
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="edExit">退出 </el-button>
                </span>
            </el-dialog>
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div>
                <span>{{prompt}}</span>
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 编辑货期记录 -->
            <el-dialog :visible.sync="ordWin" v-dialogDrag width="530px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">编辑记录</span>
                </div> 
                <div style="line-height:40px;display:flex">
                    <div style="width:110px" >订单交货周期</div>
                    <el-input  v-model="ordday"  style="width:100%" ></el-input> 
                </div>
                <div style="line-height:40px;display:flex;margin-top:20px;">
                    <div style="width:110px" >运输周期</div>
                    <el-input  v-model="shpday"  style="width:100%" ></el-input> 
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                    <span style="float:right">
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="ordWin=false" style="margin-right:50px;">取消</el-button>
                        <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="ordCfm" style="margin-right:10px;">确定</el-button>
                    </span>
                </div>
            </el-dialog>
        </div>
        <!-- FBA运费表 -->
        <div  v-if="active=='231139'" :style="{width:tabWidth}">  
            <div style="   background:#fff;line-height:35px;height:35px;  border-bottom:1px solid #389">
                <div style="font-size:16px;text-align:center;font-weight:700;color:red;width:100%">  FBA 运费计算路径</div>
            </div>
            <div style="font-size:12px;padding-left:3px;line-height:35px;background:white;width:100%"><i class="iconfont icon-xuanze1" style="color:#389;margin-right:5px"></i>1、确认商品分类</div>
            <div style="font-size:12px;padding-left:3px;line-height:35px;background:white;width:100%"><i class="iconfont icon-xuanze1" style="color:#389;margin-right:5px"></i>
                2、确认商品尺寸分段（在下表中找到测量值不超出商品的重量或尺寸的行）{计算体积、读取重量、计算体积重=（长 x 宽 x 高）除以139}--》对比选取最大的数值，见下表
            </div>
            <div :style="{ 'height':tabHigh2,'overflow-y':'auto'}">
                
                <div style="line-height:35px;display:flex;border:1px solid #ccc;background:white;color:#389;width:900px">
                    <div style="font-size:12px;width:220px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">商品尺寸分段 </div>
                    <div style="font-size:12px;width:180px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">商品重量* </div>
                    <div style="font-size:12px;width:180px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">最长边 </div>
                    <div style="font-size:12px;width:180px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">次长边</div>
                    <div style="font-size:12px;width:180px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">最短边 </div>
                    <div style="font-size:12px;width:180px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">长度 + 周长 </div>
                </div>
                <div class="fbaCss" style="line-height:35px;display:flex;border:1px solid #ccc; width:900px" v-for="(item,index) in szArr" :key="index">
                    <div style="font-size:12px;width:220px;font-weight:600; padding-left:5px;border-right:1px solid #ccc">{{item.SZLVL}} 
                    <span style="float:right;margin-right:6px;">
                        <el-link :disabled="editBool" @click="editSZ(index) " :underline="false"  ><i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-left:5px;margin-right:6px"></i></el-link> 
                    </span>
                    </div>
                    <div style="font-size:12px;width:180px;font-weight:600; padding-left:5px;border-right:1px solid #ccc">{{item.WT}} </div>
                    <div style="font-size:12px;width:180px;font-weight:600; padding-left:5px;border-right:1px solid #ccc">{{item.ONELONG}} </div>
                    <div style="font-size:12px;width:180px;font-weight:600; padding-left:5px;border-right:1px solid #ccc">{{item.TWOLONG}}</div>
                    <div style="font-size:12px;width:180px;font-weight:600; padding-left:5px;border-right:1px solid #ccc">{{item.MINLONG}} </div>
                    <div style="font-size:12px;width:180px;font-weight:600; padding-left:5px;border-right:1px solid #ccc">{{item.LONGPLUS}} </div>
                </div>
                <div style="font-size:12px;padding-left:3px;line-height:35px;background:white;width:100%"><i class="iconfont icon-xuanze1" style="color:#389;margin-right:5px"></i>
                    3、查表计算FBA费用 计算公式：首重费用+（重量-首重）* 续重费  S1/S6采用重量计算 S2-S5采用体积重计算
                </div>
                <div style="line-height:35px;display:flex;border:1px solid #ccc;background:white;color:#389;width:1250px">
                    <div style="font-size:12px;width:160px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">商品类型</div>
                    <div style="font-size:12px;width:160px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">尺寸分段 </div>
                    <div style="font-size:12px;width:260px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">发货重量 </div>
                    <div style="font-size:12px;width:180px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">非危险品和非服装</div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">首重 </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">续重费</div>
                    <div style="font-size:12px;width:160px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">服装</div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">首重 </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">续重费</div>
                    <div style="font-size:12px;width:160px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">危险品</div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">首重 </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px; ">续重费</div>
                </div>
                <div  style="border-left:1px solid #ccc; border-right:1px solid #ccc; width:1250px">
                    <div class="fbaCss" style="line-height:35px;display:flex;  width:1250px" v-for="(item,index) in prdArr" :key="index">
                        <div :class="index==prdArr.length-1?'bottom':''" style="font-size:12px;width:160px;font-weight:600;padding-left:5px; ">{{index==0?item.PRDCATE:''}}</div>
                        <div style="font-size:12px;width:160px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-left:1px solid #ccc;border-bottom:1px solid #ccc">
                            {{item.SZLVL}} 
                            <span style="float:right;margin-right:6px;">
                                <el-link :disabled="editBool" @click="editFBA(index) " :underline="false"  ><i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-left:5px;margin-right:6px"></i></el-link>
                            </span> 
                        </div>
                        <div style="font-size:12px;width:260px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.WT}}</div>
                        <div style="font-size:12px;width:180px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc;background:green;color:#fff">{{item.PRDTY}}</div>
                        <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.FWT}} </div>
                        <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.WTFEE}}</div>
                        <div style="font-size:12px;width:160px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc;background:green;color:#fff">{{item.PRDTY2}}</div>
                        <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.FWT2}} </div>
                        <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.WTFEE2}}</div>
                        <div style="font-size:12px;width:160px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc;background:green;color:#fff">{{item.PRDTY3}}</div>
                        <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.FWT3}}</div>
                        <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.WTFEE3}}</div>
                    </div>
                </div>
                <!-- 大件商品类型 -->
                <div style="margin-top:15px;line-height:35px;display:flex;border:1px solid #ccc;background:white;color:#389;width:1240px">
                    <div style="font-size:12px;width:100px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">商品类型</div>
                    <div style="font-size:12px;width:120px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">尺寸分段 </div>
                    <div style="font-size:12px;width:100px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">发货重量 </div>
                    <div style="font-size:12px;width:280px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">非危险品（服装和非服装）</div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">首重 </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">续重费</div>
                    <div style="font-size:12px;width:280px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">危险品（服装和非服装）</div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">首重 </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px; ">续重费</div>
                </div>
                <div class="fbaCss" style="line-height:35px;display:flex;  width:1240px" v-for="(item,index) in bigArr" :key="index">
                    <div :class="index==bigArr.length-1?'bottom':''" style="font-size:12px;width:100px;font-weight:600;padding-left:5px;border-right:1px solid #ccc">{{index==0?item.PRDCATE:''}}  </div>
                    <div style="font-size:12px;width:120px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">
                        {{item.SZLVL}}
                        <span style="float:right;margin-right:6px;">
                            <el-link :disabled="editBool" @click="editBIG(index) " :underline="false"  ><i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-left:5px;margin-right:6px"></i></el-link>
                        </span>
                    </div>
                    <div style="font-size:12px;width:100px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.WT}}  </div>
                    <div style="font-size:12px;width:280px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc;background:green;color:#fff">{{item.PRDTY}} </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.FWT}}  </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.WTFEE}} </div>
                    <div style="font-size:12px;width:280px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc;background:green;color:#fff">{{item.PRDTY2}} </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.FWT2}}  </div>
                    <div style="font-size:12px;width:90px;font-weight:600;padding-left:5px;border-right:1px solid #ccc;border-bottom:1px solid #ccc">{{item.WTFEE2}} </div>
                </div>
            </div>
            <!-- 编辑尺寸记录 -->
            <el-dialog :visible.sync="szWin" v-dialogDrag width="530px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">编辑记录</span>
                </div> 
                <Form  :model="szRow" :label-width="120"   label-position="right" inline >
                    <FormItem  class="item-width"  label="商品尺寸分段" >  
                        <el-input    v-model="szRow['SZLVL']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width "  label="商品重量*" >  
                        <el-input   v-model="szRow['WT']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width "  label="最长边" >  
                        <el-input  v-model="szRow['ONELONG']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width "  label="次长边" >  
                        <el-input   v-model="szRow['TWOLONG']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width "  label="最短边" >  
                        <el-input   v-model="szRow['MINLONG']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width "  label="长度 + 周长" >  
                        <el-input   v-model="szRow['LONGPLUS']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width "  label="主键ID" >  
                        <el-input  disabled v-model="szRow['IDSEQ']"  style="width:100%" ></el-input> 
                    </FormItem>
                </Form>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                    <span style="float:right">
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="szWin=false" style="margin-right:50px;">取消</el-button>
                        <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="szSave" style="margin-right:10px;">确定</el-button>
                    </span>
                </div>
            </el-dialog>
            <!-- 编辑FBA -->
            <el-dialog :visible.sync="fbaWin" v-dialogDrag width="900px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">编辑记录</span>
                </div> 
                <Form  :model="fbaRow" :label-width="120"   label-position="right" inline >
                    <FormItem  class="item-width2"  label="商品类型" >  
                        <el-input   disabled  v-model="fbaRow['PRDCATE']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="尺寸分段" >  
                        <el-input   disabled v-model="fbaRow['SZLVL']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="发货重量" >  
                        <el-input   v-model="fbaRow['WT']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="非危险品和非服装" >  
                        <el-input   v-model="fbaRow['PRDTY']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="首重" >  
                        <el-input   v-model="fbaRow['FWT']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="续重费" >  
                        <el-input   v-model="fbaRow['WTFEE']"  style="width:100%" ></el-input> 
                    </FormItem>

                    <FormItem  class="item-width2 "  label="服装" >  
                        <el-input   v-model="fbaRow['PRDTY2']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="服装首重" >  
                        <el-input   v-model="fbaRow['FWT2']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="服装续重费" >  
                        <el-input   v-model="fbaRow['WTFEE2']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="危险品" >  
                        <el-input   v-model="fbaRow['PRDTY3']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="危险品首重" >  
                        <el-input   v-model="fbaRow['FWT3']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="危险品续重费" >  
                        <el-input   v-model="fbaRow['WTFEE']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="主键ID" >  
                        <el-input   disabled v-model="fbaRow['IDSEQ']"  style="width:100%" ></el-input> 
                    </FormItem>
                </Form>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                    <span style="float:right">
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="fbaWin=false" style="margin-right:50px;">取消</el-button>
                        <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="fbaSave" style="margin-right:10px;">确定</el-button>
                    </span>
                </div>
            </el-dialog>
            <!-- 编辑BIG FBA -->
            <el-dialog :visible.sync="bigWin" v-dialogDrag width="950px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">编辑记录</span>
                </div> 
                <Form  :model="bigRow" :label-width="140"   label-position="right" inline >
                    <FormItem  class="item-width2"  label="商品类型" >  
                        <el-input   disabled  v-model="bigRow['PRDCATE']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="尺寸分段" >  
                        <el-input   disabled v-model="bigRow['SZLVL']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="发货重量" >  
                        <el-input   v-model="bigRow['WT']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="非危险品(服装和非服装)" >  
                        <el-input   v-model="bigRow['PRDTY']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="首重" >  
                        <el-input  v-model="bigRow['FWT']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="续重费" >  
                        <el-input   v-model="bigRow['WTFEE']"  style="width:100%" ></el-input> 
                    </FormItem>

                    <FormItem  class="item-width2 "  label="危险品(服装和非服装)" >  
                        <el-input  v-model="bigRow['PRDTY2']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="危险品首重" >  
                        <el-input  v-model="bigRow['FWT2']"  style="width:100%" ></el-input> 
                    </FormItem>
                    <FormItem  class="item-width2 "  label="危险品续重费" >  
                        <el-input   v-model="bigRow['WTFEE2']"  style="width:100%" ></el-input> 
                    </FormItem>                  
                    <FormItem  class="item-width2 "  label="主键ID" >  
                        <el-input  disabled v-model="bigRow['IDSEQ']"  style="width:100%" ></el-input> 
                    </FormItem>
                </Form>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                    <span style="float:right">
                        <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="bigWin=false" style="margin-right:50px;">取消</el-button>
                        <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="bigSave" style="margin-right:10px;">确定</el-button>
                    </span>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import bsCrcy from './bs_crcy.vue' 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
//局部注册
export default {
    name:"amz_rule",
    data () {
        return {
            editWin:false,
            ordday:'',
            mthArr:[],
            shpday:'',
            promptWin:false,
            prompt:'',
            ordWin:false,
            menuList: [],
            openName:[], //模块ID集合
            cpWin:false,
            frmth:'',
            tomth:'',
            active:'', //二级菜单选中标志
            szArr:[],
            disabled:false, //新增权限制
            szWin:false,
            szRow:{},
            bigArr:[],
            tabData:[], //表数据
            tabArr:[], //表列 
            fbaWin:false,
            prdArr:[],
            fbaRow:{},
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            bigIndex:'',
            bigWin:false,
            bigRow:{},
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            szIndex:'',
            fbaIndex:'',
            m3Arr:[],
            idseq:'',
            ordArr:[],
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
 
        }
    },
    mounted () { 
 
        getBaseData('xuper_auth/getBaseData','','','','','V_YRMTH',' and substr(code,1,4)=2022').then(res=>{
            this.mthArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','','','','','V_YRMTH',' and substr(code,1,4)=2023').then(res=>{
            this.m3Arr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','126989','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                } 
            }
        })  
 
        this.getCrcyList('')
        this.getFBAList()
    },
    computed: {
        tabWidth: function() {
            return (window.innerWidth-100) + 'px';
        }, 
        divWidth: function() {
            return (window.innerWidth - 290) + 'px';
        }, 
        tabHigh: function() {
            return (window.innerHeight-210) + 'px';
        }, 
        tabHigh2: function() {
            return (window.innerHeight-210) + 'px';
        }, 
    },
    components: {
        bsCrcy,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
           
            this.getTabField() //表列字段
            this.getMenuList()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        //BIG
        editBIG(index){
            this.bigIndex =index
            this.bigWin =true
            this.bigRow =JSON.parse(JSON.stringify(this.bigArr[index] ))
        },
        bigSave(){
           this.$axios({
                method: 'post',
                url:'xuper_auth/formOneSave',
                data: {p_json:JSON.stringify(this.bigRow), p_table:'AMZ_RULE',p_frmid:''},
            }).then(res=>{   
                this.bigArr.splice(this.bigIndex,1,this.bigRow)
                this.bigWin=false
            })
        },
        //FBA
        editFBA(index){
            this.fbaIndex =index
            this.fbaWin =true
            this.fbaRow =JSON.parse(JSON.stringify(this.prdArr[index] ))
        },
        fbaSave(){
           this.$axios({
                method: 'post',
                url:'xuper_auth/formOneSave',
                data: {p_json:JSON.stringify(this.fbaRow), p_table:'AMZ_RULE',p_frmid:''},
            }).then(res=>{   
                this.prdArr.splice(this.fbaIndex,1,this.fbaRow)
                this.fbaWin=false
            })
        },
        szSave(){
           this.$axios({
                method: 'post',
                url:'xuper_auth/formOneSave',
                data: {p_json:JSON.stringify(this.szRow), p_table:'AMZ_RULE',p_frmid:''},
            }).then(res=>{   
                this.szArr.splice(this.szIndex,1,this.szRow)
                this.szWin=false
            })
        },
        editSZ(index){
            this.szIndex =index
            this.szWin =true
            this.szRow =JSON.parse(JSON.stringify(this.szArr[index] ))
        },
        ordCfm(){
           this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.idseq ,p_table:'amz_rule',p_cond:' set ordday=\''+this.ordday+'\',shpday=\''+this.shpday+'\'' },
            }).then(res=>{ 
                this.ordWin=false
                this.getFBAList()
            }) 
        },
        edExit(){
            this.editWin = false
            this.getCrcyList('')
        },
        editRec(){
            this.editWin =true
        },
        editShp(){
            this.ordWin=true
            this.ordday=this.ordArr[0]['ORDDAY']
            this.shpday=this.ordArr[0]['SHPDAY']
        },
        //货币明细
        getCrcyList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond ,p_table:'V_AMZ_CRCY'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
 
            }) 
        },
        //FBA明细
        getFBAList(){
            this.ordArr=[]  
            this.szArr=[]   
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_cond:' order by idseq', p_table:'V_AMZ_RULE'},
            }).then(res=>{ 
                res.result.forEach(item =>{
                    if (item['IDTY']=='ORD'){
                        this.ordArr.push(item)
                        this.idseq =item['IDSEQ']
                    }else if (item['IDTY']=='SIZE'){
                        this.szArr.push(item)
                    }else if (item['IDTY']=='PRD'){
                        this.prdArr.push(item)
                    }else if (item['IDTY']=='BIG'){
                        this.bigArr.push(item)
                    }

                })
            }) 
        },
 
        //左边菜单
        getMenuList(){
            this.$axios({
                method:'post',
                url: 'xuper_auth/getSubList' ,
                data:{maintab:'V_SUPTY',p_key:'CODE',p_value:'231137',subtab:'V_SUPTYITM'},
            }).then(res =>{
                this.menuList =res.result
                //初始化选中第一个
                this.active =res.result[0].subs[0].frmurl
                this.queryEvent( this.active)
                for (let k=0;k<res.result.length;k++){
                    this.openName.push(res.result[k].subno)
                } 
            })
        },
        queryEvent( frmurl){
           this.getCrcyList('')
             
        },
        //二级菜单点击事件
        itemClick(frmurl ){
            console.log(frmurl)
            this.active =frmurl
            this.queryEvent( frmurl)
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4265','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .divcss {
        width:160px;
        border:1px solid #ccc;
        text-align:center;
        font-size:12px;
        font-weight:600;
    }
    .divcss2 {
        width:110px;
        border:1px solid #ccc;
        text-align:center;
        font-size:12px;
 
    }
    .fbaCss{
        background:white;
    }
    .fbaCss:hover{
        background: rgb(188, 222, 250);
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #808694;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
 
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 98%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .item-width2{
        width: 48%;
        color:#409EFF;
    }
    .bottom{
        border-bottom:1px solid #ccc;
    }
</style>
<style lang="less">
 
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 